<template>
  <div>
    <div v-if="params.data.status === 1 && $can('edit_sub_users')">
      <vs-button
        id="settings-users-table-view-button"
        :to="'/settings/users/'+ params.data.user_id"
        type="flat"
        class="pl-5 font-medium text-lg"
      >View
      </vs-button>
    </div>
    <div v-if="params.data.status !== 1">
      <vs-button
        id="settings-users-table-resend-button"
        @click="resendInvitation(params.data.id)"
        type="flat"
        class="pl-5 whitespace-no-wrap font-medium text-lg"
      >Resend Invitation
      </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    async resendInvitation (id) {
      await this.params.context.parent.resendInvitation(id)
    }
  }
}
</script>
